import './bootstrap';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { cssVariables } from './theme/cssVars';
import './theme/global.css';

// One source for design values: the app's own token module, emitted as custom properties
// before the first paint so global.css and every component read the same numbers.
const vars = document.createElement('style');
vars.textContent = cssVariables();
document.head.prepend(vars);

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');
createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
